<div class="settings-container">
  <button *ngIf="allowAdminRescue" mat-icon-button (click)="startupService.selectRole('organization', '' + organization.ID, organization.name)"><mat-icon>supervised_user_circle</mat-icon></button>

  <!-- Sticky Save/Cancel Bar -->
  <div class="settings-actions" *ngIf="editOrganization">
    <button mat-raised-button color="primary" (click)="save()" [disabled]="!hasChanges" i18n-title="@@Save" title="Save"><mat-icon>save</mat-icon> <span i18n="@@Save">Save</span></button>
    <button mat-raised-button (click)="cancel()" i18n-title="dialog dismissal|Button that closes a dialog and discards any unsaved edits. It never removes or destroys existing data - the Delete button does that. Must translate to a word meaning 'abandon this action', not 'erase'.@@Cancel" title="Cancel"><mat-icon>cancel</mat-icon> <span i18n="dialog dismissal|Button that closes a dialog and discards any unsaved edits. It never removes or destroys existing data - the Delete button does that. Must translate to a word meaning 'abandon this action', not 'erase'.@@Cancel">Cancel</span></button>
  </div>
  <div class="settings-actions" *ngIf="!editOrganization && startupService.selectedRole === 'organization'">
    <button mat-raised-button color="primary" (click)="edit()" i18n-title="@@Edit" title="Edit"><mat-icon>edit</mat-icon> <span i18n="@@Edit">Edit</span></button>
  </div>

  <mat-accordion multi="true" displayMode="flat">

    <!-- Section: Name -->
    <mat-expansion-panel [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon class="section-icon">badge</mat-icon>
          <span i18n="@@Name">Name</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <form class="section-form">
        <h3 class="settings-heading" i18n="@@Name">Name</h3>
        <div class="settings-description" i18n="@@settingsNameDescription">Your name will be shown on the ship from field on shipping labels.</div>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label i18n="@@Name">Name</mat-label>
          <textarea name="name" [(ngModel)]="editableOrganization.name" matInput></textarea>
        </mat-form-field>
        <h3 class="settings-heading" i18n="@@Description">Description</h3>
        <div class="settings-description" i18n="@@settingsDescription">Describe what you do.</div>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label i18n="@@Description">Description</mat-label>
          <textarea name="description" [(ngModel)]="editableOrganization.description" matInput></textarea>
        </mat-form-field>
      </form>
    </mat-expansion-panel>

    <!-- Section: Sales Tax -->
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon class="section-icon">receipt_long</mat-icon>
          <span i18n="@@Sales Tax">Sales Tax</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <form class="section-form">
        <h3 class="settings-heading" i18n="@@Exemption Type">Exemption Type</h3>
        <div class="settings-description" i18n="@@salesTaxExemptionTypeDescription">Choose how this organization claims sales-tax exemption.</div>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label i18n="@@Exemption Type">Exemption Type</mat-label>
          <mat-select name="salesTaxExemptionType" [(ngModel)]="editableOrganization.salesTaxExemptionType">
            <mat-option value="non_exempt" i18n="@@Non Exempt">Non Exempt</mat-option>
            <mat-option value="wholesale" i18n="@@Wholesale">Wholesale</mat-option>
            <mat-option value="other" i18n="@@Non Profit">Non Profit</mat-option>
            <mat-option *ngIf="startupService.isNetwork()" value="government" i18n="@@Government">Government</mat-option>
            <mat-option *ngIf="startupService.isNetwork()" value="marketplace" i18n="@@Marketplace">Marketplace</mat-option>
          </mat-select>
        </mat-form-field>
      </form>
    </mat-expansion-panel>

    <!-- Section: Contact Information -->
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon class="section-icon">contact_mail</mat-icon>
          <span i18n="@@ContactInformation">Contact Information</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <form class="section-form address-form">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label i18n="@@Name">Name</mat-label>
          <textarea name="contactName" [(ngModel)]="editableOrganization.contactName" matInput></textarea>
        </mat-form-field>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label i18n="@@CompanyName">Company Name</mat-label>
          <textarea name="contactCompanyName" [(ngModel)]="editableOrganization.contactCompanyName" matInput></textarea>
        </mat-form-field>
        <div class="form-row">
          <mat-form-field appearance="outline" class="flex-field">
            <mat-label i18n="@@Address">Address</mat-label>
            <textarea name="contactAddress1" [(ngModel)]="editableOrganization.contactAddress1" matInput></textarea>
          </mat-form-field>
          <mat-form-field appearance="outline" class="flex-field">
            <mat-label i18n="@@Address 2">Address 2</mat-label>
            <textarea name="contactAddress2" [(ngModel)]="editableOrganization.contactAddress2" matInput></textarea>
          </mat-form-field>
        </div>
        <div class="form-row">
          <mat-form-field appearance="outline" class="flex-field">
            <mat-label i18n="@@City">City</mat-label>
            <input name="contactCity" [(ngModel)]="editableOrganization.contactCity" matInput>
          </mat-form-field>
          <mat-form-field appearance="outline" class="flex-field">
            <mat-label i18n="@@State">State</mat-label>
            <input name="contactState" [(ngModel)]="editableOrganization.contactState" matInput>
          </mat-form-field>
        </div>
        <div class="form-row">
          <mat-form-field appearance="outline" class="flex-field">
            <mat-label i18n="@@Country">Country</mat-label>
            <mat-select name="contactCountry" [(ngModel)]="editableOrganization.contactCountry">
              <mat-option i18n="@@None">None</mat-option>
              <mat-option value="US" i18n="@@United States">United States</mat-option>
              <mat-option value="CA" i18n="@@Canada">Canada</mat-option>
              <mat-option value="GB" i18n="@@United Kingdom">United Kingdom</mat-option>
              <mat-option value="AU" i18n="@@Australia">Australia</mat-option>
              <mat-option value="DE" i18n="@@Germany">Germany</mat-option>
              <mat-option value="FR" i18n="@@France">France</mat-option>
              <mat-option value="JP" i18n="@@Japan">Japan</mat-option>
              <mat-option value="CN" i18n="@@China">China</mat-option>
              <mat-option value="IN" i18n="@@India">India</mat-option>
              <mat-option value="BR" i18n="@@Brazil">Brazil</mat-option>
              <mat-option value="MX" i18n="@@Mexico">Mexico</mat-option>
              <mat-option value="IT" i18n="@@Italy">Italy</mat-option>
              <mat-option value="ES" i18n="@@Spain">Spain</mat-option>
              <mat-option value="NL" i18n="@@Netherlands (Holland, Europe)">Netherlands</mat-option>
              <mat-option value="SE" i18n="@@Sweden">Sweden</mat-option>
              <mat-option value="NO" i18n="@@Norway">Norway</mat-option>
              <mat-option value="DK" i18n="@@Denmark">Denmark</mat-option>
              <mat-option value="PL" i18n="@@Poland">Poland</mat-option>
              <mat-option value="RU" i18n="@@Russia">Russia</mat-option>
              <mat-option value="KR" i18n="@@Korea South">Korea South</mat-option>
              <mat-option value="SG" i18n="@@Singapore">Singapore</mat-option>
              <mat-option value="NZ" i18n="@@New Zealand">New Zealand</mat-option>
              <mat-option value="ZA" i18n="@@South Africa">South Africa</mat-option>
              <mat-option value="AE" i18n="@@United Arab Emirates">United Arab Emirates</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" class="flex-field">
            <mat-label i18n="@@Zip">Zip</mat-label>
            <input name="contactPostal" [(ngModel)]="editableOrganization.contactPostal" matInput>
          </mat-form-field>
        </div>
        <div class="form-row">
          <mat-form-field appearance="outline" class="flex-field">
            <mat-label i18n="@@Phone">Phone</mat-label>
            <input name="contactPhone" [(ngModel)]="editableOrganization.contactNumber" matInput>
          </mat-form-field>
          <mat-form-field appearance="outline" class="flex-field">
            <mat-label i18n="@@Email">Email</mat-label>
            <input name="contactEmail" [(ngModel)]="editableOrganization.contactEmail" matInput>
          </mat-form-field>
        </div>
      </form>
    </mat-expansion-panel>

    <!-- Section: Ship From Address -->
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon class="section-icon">local_shipping</mat-icon>
          <span i18n="origin address|The address a shipment leaves FROM - the organization's own dispatch address. The opposite end of the journey from Ship To Address. A translation that reads simply 'shipping address' is wrong here, because it is indistinguishable from the destination.@@Ship From Address">Ship From Address</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="settings-description" i18n="@@ShipFromAddressDescription">Brand your shipping labels by adding your company address.</div>
      <mat-radio-group class="radio-group-vertical" (change)="editableOrganization.defaultFromAddress = !editableOrganization.defaultFromAddress">
        <mat-radio-button [checked]="editableOrganization.defaultFromAddress" [value]="editableOrganization.defaultFromAddress">
          <span i18n="@@UseDefaultFromShippingAddress">The return address will be the location where the book was printed.</span>
        </mat-radio-button>
        <mat-radio-button [checked]="!editableOrganization.defaultFromAddress" [value]="!editableOrganization.defaultFromAddress">
          <span i18n="@@UseCustomFromShippingAddress">The ship from address will be your address. Note: the address must be a valid US address.</span>
        </mat-radio-button>
      </mat-radio-group>
      <form *ngIf="!editableOrganization.defaultFromAddress" class="section-form address-form">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label i18n="@@Name">Name</mat-label>
          <textarea name="fromName" [(ngModel)]="editableOrganization.fromName" matInput></textarea>
        </mat-form-field>
        <div class="form-row">
          <mat-form-field appearance="outline" class="flex-field">
            <mat-label i18n="@@Address">Address</mat-label>
            <textarea name="fromAddress1" [(ngModel)]="editableOrganization.fromAddress1" matInput></textarea>
          </mat-form-field>
          <mat-form-field appearance="outline" class="flex-field">
            <mat-label i18n="@@Address 2">Address 2</mat-label>
            <textarea name="fromAddress2" [(ngModel)]="editableOrganization.fromAddress2" matInput></textarea>
          </mat-form-field>
        </div>
        <div class="form-row">
          <mat-form-field appearance="outline" class="flex-field">
            <mat-label i18n="@@City">City</mat-label>
            <input name="fromCity" [(ngModel)]="editableOrganization.fromCity" matInput>
          </mat-form-field>
          <mat-form-field appearance="outline" class="flex-field">
            <mat-label i18n="@@State">State</mat-label>
            <input name="fromState" [(ngModel)]="editableOrganization.fromState" matInput>
          </mat-form-field>
        </div>
        <div class="form-row">
          <mat-form-field appearance="outline" class="flex-field">
            <mat-label i18n="@@Country">Country</mat-label>
            <mat-select name="fromCountry" [(ngModel)]="editableOrganization.fromCountry">
              <mat-option i18n="@@None">None</mat-option>
              <mat-option value="US" i18n="@@United States">United States</mat-option>
              <mat-option value="CA" i18n="@@Canada">Canada</mat-option>
              <mat-option value="GB" i18n="@@United Kingdom">United Kingdom</mat-option>
              <mat-option value="AU" i18n="@@Australia">Australia</mat-option>
              <mat-option value="DE" i18n="@@Germany">Germany</mat-option>
              <mat-option value="FR" i18n="@@France">France</mat-option>
              <mat-option value="JP" i18n="@@Japan">Japan</mat-option>
              <mat-option value="CN" i18n="@@China">China</mat-option>
              <mat-option value="IN" i18n="@@India">India</mat-option>
              <mat-option value="MX" i18n="@@Mexico">Mexico</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" class="flex-field">
            <mat-label i18n="@@Zip">Zip</mat-label>
            <input name="fromPostalcode" [(ngModel)]="editableOrganization.fromPostal" matInput>
          </mat-form-field>
        </div>
        <div class="form-row">
          <mat-form-field appearance="outline" class="flex-field">
            <mat-label i18n="@@Phone">Phone</mat-label>
            <input name="fromPhone" [(ngModel)]="editableOrganization.fromPhone" matInput>
          </mat-form-field>
          <mat-form-field appearance="outline" class="flex-field">
            <mat-label i18n="@@Email">Email</mat-label>
            <input name="fromEmail" [(ngModel)]="editableOrganization.fromEmail" matInput>
          </mat-form-field>
        </div>
      </form>
    </mat-expansion-panel>

    <!-- Section: Return Address -->
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon class="section-icon">undo</mat-icon>
          <span i18n="@@Return Address For Shipping Label">Return Address For Shipping Label</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <mat-radio-group class="radio-group-vertical" (change)="editableOrganization.defaultReturnAddress = !editableOrganization.defaultReturnAddress">
        <mat-radio-button [checked]="editableOrganization.defaultReturnAddress" [value]="editableOrganization.defaultReturnAddress">
          <span i18n="@@UseDefaultFromShippingAddress">The return address will be the location where the book was printed.</span>
        </mat-radio-button>
        <mat-radio-button [checked]="!editableOrganization.defaultReturnAddress" [value]="!editableOrganization.defaultReturnAddress">
          <span i18n="@@UseCustomReturnAddress">The return address will be your address. Note: This information will be used, if possible, to redirect packages to you if your customer's address is invalid. This address must be in the United States and cannot be a Post Office Box.</span>
        </mat-radio-button>
      </mat-radio-group>
      <form *ngIf="!editableOrganization.defaultReturnAddress" class="section-form address-form">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label i18n="@@Name">Name</mat-label>
          <textarea name="returnName" [(ngModel)]="editableOrganization.returnName" matInput></textarea>
        </mat-form-field>
        <div class="form-row">
          <mat-form-field appearance="outline" class="flex-field">
            <mat-label i18n="@@Address">Address</mat-label>
            <textarea name="returnAddress1" [(ngModel)]="editableOrganization.returnAddress1" matInput></textarea>
          </mat-form-field>
          <mat-form-field appearance="outline" class="flex-field">
            <mat-label i18n="@@Address 2">Address 2</mat-label>
            <textarea name="returnAddress2" [(ngModel)]="editableOrganization.returnAddress2" matInput></textarea>
          </mat-form-field>
        </div>
        <div class="form-row">
          <mat-form-field appearance="outline" class="flex-field">
            <mat-label i18n="@@City">City</mat-label>
            <input name="returnCity" [(ngModel)]="editableOrganization.returnCity" matInput>
          </mat-form-field>
          <mat-form-field appearance="outline" class="flex-field">
            <mat-label i18n="@@State">State</mat-label>
            <input name="returnState" [(ngModel)]="editableOrganization.returnState" matInput>
          </mat-form-field>
        </div>
        <div class="form-row">
          <mat-form-field appearance="outline" class="flex-field">
            <mat-label i18n="@@Country">Country</mat-label>
            <mat-select name="returnCountry" [(ngModel)]="editableOrganization.returnCountry">
              <mat-option i18n="@@None">None</mat-option>
              <mat-option value="US" i18n="@@United States">United States</mat-option>
              <mat-option value="CA" i18n="@@Canada">Canada</mat-option>
              <mat-option value="GB" i18n="@@United Kingdom">United Kingdom</mat-option>
              <mat-option value="AU" i18n="@@Australia">Australia</mat-option>
              <mat-option value="DE" i18n="@@Germany">Germany</mat-option>
              <mat-option value="FR" i18n="@@France">France</mat-option>
              <mat-option value="JP" i18n="@@Japan">Japan</mat-option>
              <mat-option value="CN" i18n="@@China">China</mat-option>
              <mat-option value="IN" i18n="@@India">India</mat-option>
              <mat-option value="MX" i18n="@@Mexico">Mexico</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" class="flex-field">
            <mat-label i18n="@@Zip">Zip</mat-label>
            <input name="returnPostalcode" [(ngModel)]="editableOrganization.returnPostal" matInput>
          </mat-form-field>
        </div>
        <div class="form-row">
          <mat-form-field appearance="outline" class="flex-field">
            <mat-label i18n="@@Phone">Phone</mat-label>
            <input name="returnPhone" [(ngModel)]="editableOrganization.returnPhone" matInput>
          </mat-form-field>
          <mat-form-field appearance="outline" class="flex-field">
            <mat-label i18n="@@Email">Email</mat-label>
            <input name="returnEmail" [(ngModel)]="editableOrganization.returnEmail" matInput>
          </mat-form-field>
        </div>
      </form>
    </mat-expansion-panel>

    <!-- Section: Notifications -->
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon class="section-icon">notifications</mat-icon>
          <span i18n="@@Notifications">Notifications</span>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="notification-subsection">
        <h3 class="settings-heading" i18n="@@OrderConfirmationNotifications">Order Confirmation Notifications</h3>
        <div class="settings-description" i18n="@@OrderConfirmationNotificationsDescription">Choose how you would like to receive order confirmation notifications.</div>
        <mat-radio-group class="radio-group-vertical" (change)="editableOrganization.orderConfirmationNotificationType = $event.value">
          <mat-radio-button [checked]="editableOrganization.orderConfirmationNotificationType === 'ASAP'" value="ASAP">
            <div class="radio-option">
              <strong i18n="@@ReceiveAsSoonAsPossible">Receive as soon as possible.</strong>
              <div class="radio-option-description" i18n="@@ReceiveAsSoonAsPossibleDescription">Order confirmation details will be sent as soon as the order is confirmed.</div>
            </div>
          </mat-radio-button>
          <mat-radio-button [checked]="editableOrganization.orderConfirmationNotificationType === 'DAILY'" value="DAILY">
            <div class="radio-option">
              <strong i18n="@@ReceiveDaily">Receive daily.</strong>
              <div class="radio-option-description" i18n="@@ReceiveDailyDescription">Order confirmation details will be sent to you in a single email every day.</div>
            </div>
          </mat-radio-button>
          <mat-radio-button [checked]="editableOrganization.orderConfirmationNotificationType === 'NEVER'" value="NEVER">
            <div class="radio-option">
              <strong i18n="@@IDontNeedOrderConfirmationEmails">I don't need order confirmation emails.</strong>
              <div class="radio-option-description" i18n="@@IDontNeedOrderConfirmationEmailsDescription">Order confirmation details will not be sent via email. Details will always be available online in your account.</div>
            </div>
          </mat-radio-button>
        </mat-radio-group>
        <mat-form-field *ngIf="editableOrganization.orderConfirmationNotificationType !== 'NEVER'" appearance="outline" class="full-width">
          <mat-label i18n="@@EmailForOrderConfirmations">Email for order confirmations</mat-label>
          <textarea name="emailForOrderConfirmations" [(ngModel)]="editableOrganization.orderConfirmationEmail" matInput></textarea>
        </mat-form-field>
      </div>

      <mat-divider></mat-divider>

      <div class="notification-subsection">
        <h3 class="settings-heading" i18n="@@ShipmentConfirmationNotifications">Shipment Confirmation Notifications</h3>
        <div class="settings-description" i18n="@@ShipmentConfirmationDescription">Choose how you would like to receive shipment confirmation notifications.</div>
        <mat-radio-group class="radio-group-vertical" (change)="editableOrganization.shipmentConfirmationNotificationType = $event.value">
          <mat-radio-button [checked]="editableOrganization.shipmentConfirmationNotificationType === 'ASAP'" value="ASAP">
            <div class="radio-option">
              <strong i18n="@@ReceiveAsSoonAsPossible">Receive as soon as possible.</strong>
              <div class="radio-option-description" i18n="@@ReceiveAsSoonAsPossibleDescription">Order confirmation details will be sent as soon as the order is confirmed.</div>
            </div>
          </mat-radio-button>
          <mat-radio-button [checked]="editableOrganization.shipmentConfirmationNotificationType === 'DAILY'" value="DAILY">
            <div class="radio-option">
              <strong i18n="@@ReceiveDaily">Receive daily.</strong>
              <div class="radio-option-description" i18n="@@ShipmentConfirmationDailyDescription">Shipment confirmation details will be sent to you in a single email every day.</div>
            </div>
          </mat-radio-button>
          <mat-radio-button [checked]="editableOrganization.shipmentConfirmationNotificationType === 'NEVER'" value="NEVER">
            <div class="radio-option">
              <strong i18n="@@IDontNeedShipmentConfirmationEmails">I don't need shipment confirmation emails.</strong>
              <div class="radio-option-description" i18n="@@IDontNeedShipmentConfirmationEmailsDescription">Shipment confirmation details will not be sent via email. Details will always be available online in your account.</div>
            </div>
          </mat-radio-button>
        </mat-radio-group>
        <mat-form-field *ngIf="editableOrganization.shipmentConfirmationNotificationType !== 'NEVER'" appearance="outline" class="full-width">
          <mat-label i18n="@@EmailForShipmentConfirmations">Email for shipment confirmations</mat-label>
          <textarea name="emailForShipmentConfirmations" [(ngModel)]="editableOrganization.shipmentNoticeEmail" matInput></textarea>
        </mat-form-field>
      </div>
    </mat-expansion-panel>

    <!-- Section: Shipping Label Branding Image -->
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon class="section-icon">image</mat-icon>
          <span i18n="@@ShippingLabelBrandingImage">Shipping Label Branding Image</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="settings-description" i18n="@@ShippingLabelBrandingImageDescription">Upload a greyscale image to be printed on a portion of a 4in x 6in label on each package in addition to the shipping label. The image will be printed 4.5in x 3.5in and must be a PNG format black and white image and be 675px by 525px.</div>
    </mat-expansion-panel>

    <!-- Section: Preferred Shipping (cart redesign S-7) -->
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon class="section-icon">local_shipping</mat-icon>
          <span i18n="@@PreferredShipping">Preferred Shipping</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="settings-description" i18n="@@PreferredShippingDescription">When set, the shopping cart auto-selects the matching carrier and service level on checkout if it is available for the chosen production facility. Leave blank for no preference.</div>
      <form class="section-form">
        <div class="form-row">
          <mat-form-field appearance="outline" class="flex-field">
            <mat-label i18n="@@Preferred Carrier">Preferred Carrier</mat-label>
            <input i18n-placeholder="@@e.g. USPS, UPS, FEDEX" matInput name="preferredCarrier" [(ngModel)]="editableOrganization.preferredCarrier" list="preferredCarrierSuggestions" placeholder="e.g. USPS, UPS, FEDEX">
            <datalist id="preferredCarrierSuggestions">
              <option value="USPS"></option>
              <option value="UPS"></option>
              <option value="FEDEX"></option>
            </datalist>
          </mat-form-field>
          <mat-form-field appearance="outline" class="flex-field">
            <mat-label i18n="@@Preferred Service Level">Preferred Service Level</mat-label>
            <input i18n-placeholder="@@e.g. GROUND, PRIORITY" matInput name="preferredServiceLevel" [(ngModel)]="editableOrganization.preferredServiceLevel" list="preferredServiceLevelSuggestions" placeholder="e.g. GROUND, PRIORITY">
            <datalist id="preferredServiceLevelSuggestions">
              <option value="GROUND"></option>
              <option value="PRIORITY"></option>
              <option value="PRIORITY_FLAT"></option>
              <option value="FIRSTCLASS"></option>
              <option value="OVERNIGHT"></option>
            </datalist>
          </mat-form-field>
        </div>
      </form>
    </mat-expansion-panel>

    <!-- Section: Service Provider Admin (conditional) -->
    <mat-expansion-panel *ngIf="startupService.selectedRole === 'serviceProvider' || startupService.selectedRole === 'network'">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon class="section-icon">admin_panel_settings</mat-icon>
          <span i18n="@@Admin Settings">Admin Settings</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="section-form">
        <h3 class="settings-heading" i18n="@@Micro Inventory">Micro Inventory</h3>
        <button *ngIf="editableOrganization.microInventory === 'ACTIVE'" mat-raised-button color="warn" (click)="revokeMicroInventory(editableOrganization)" i18n="@@Revoke Micro Inventory Privileges">Revoke Micro Inventory Privileges</button>
        <button *ngIf="editableOrganization.microInventory === 'INACTIVE' || editableOrganization.microInventory === 'INITIAL'" mat-raised-button color="primary" (click)="grantMicroInventory(editableOrganization)" i18n="@@Grant Micro Inventory Privileges">Grant Micro Inventory Privileges</button>
      </div>
    </mat-expansion-panel>

    <!-- Section: Rate Configuration Override (organization-level)
         Only the network and the parent service provider can edit/view this.
         End users acting as the organization must NOT see or edit it (they
         could otherwise grant themselves discounts). -->
    <mat-expansion-panel *ngIf="startupService.selectedRole === 'serviceProvider' || startupService.selectedRole === 'network'">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon class="section-icon">tune</mat-icon>
          <span i18n="@@Rate Configuration Override">Rate Configuration Override</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="settings-description" i18n="@@OrgRateConfigOverrideDescription">Override the rate configuration inherited from the parent service provider. Only the fields you set here apply; everything else falls through to the service-provider defaults.</div>
      <app-rate-config-editor
        subjectKind="organization"
        [subjectId]="organization.ID"
        documentProperty="rateConfigOverride"
        editorMode="OVERRIDE">
      </app-rate-config-editor>
    </mat-expansion-panel>

    <!-- Section: Packing Rate Configuration Override (organization-level)
         Same role-gating policy as the production override above: only
         the network and the parent service provider may edit/view it.
         End users acting as the organization must NOT see or edit it
         (otherwise they could grant themselves packing discounts). -->
    <mat-expansion-panel *ngIf="startupService.selectedRole === 'serviceProvider' || startupService.selectedRole === 'network'">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon class="section-icon">inventory_2</mat-icon>
          <span i18n="@@Packing Rate Configuration Override">Packing Rate Configuration Override</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="settings-description" i18n="@@OrgPackingRateConfigOverrideDescription">Override the packing/packaging rate configuration inherited from the parent service provider. Only the fields you set here apply; everything else falls through to the service-provider defaults.</div>
      <app-rate-config-editor
        subjectKind="organization"
        [subjectId]="organization.ID"
        documentProperty="packingRateConfigOverride"
        editorMode="OVERRIDE">
      </app-rate-config-editor>
    </mat-expansion-panel>

  </mat-accordion>
</div>
